import { store } from "../store";
import { resolveLanguage } from "./language";

export function getSignalingUrl(peerId, roomName, roomId, token) {
  const hostname = window.config.serverUrl;
  const language = resolveLanguage(store.getState().user.userLanguage);

  const port =
    process.env.NODE_ENV !== "production"
      ? window.config.developmentPort
      : window.config.productionPort;

  return `wss://${hostname}:${port}/?peerId=${peerId}&roomId=${roomId}&roomName=${roomName}&userToken=${token}&userLanguage=${language}`;
}
